import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, clone, isEmpty } from 'lodash';
import ProtectionPlansPenRegistration from './ProtectionPlansPenRegistration';
import ProtectionPlansPenProducts from './ProtectionPlansPenProducts';
import ProtectionPlansPenBundles from './ProtectionPlansPenBundles';
import StepList from '../StepList';
import { protectionPlanSteps } from '../../util/constants';

function ProtectionPlansPen(props) {
  const { page, dealer, actions, history, pen, fetching } = props;

  useEffect(() => {
    if (
      isEmpty(dealer.penConfig) &&
      page !== protectionPlanSteps.REGISTRATION
    ) {
      props.history.push(`/${dealer.id}/protection-plans/registration`);
    } else if (
      !isEmpty(dealer.penConfig) &&
      page === protectionPlanSteps.REGISTRATION
    ) {
      props.history.push(`/${dealer.id}/protection-plans/products`);
    }
  });

  const steps = [
    {
      title: 'Products',
      param: protectionPlanSteps.PRODUCTS,
    },
    {
      title: 'Bundles',
      param: protectionPlanSteps.BUNDLES,
    },
  ];

  const renderPenPage = (pg) => {
    switch (pg) {
      case protectionPlanSteps.REGISTRATION:
        return (
          <ProtectionPlansPenRegistration dealer={dealer} actions={actions} />
        );
      case protectionPlanSteps.PRODUCTS:
        return (
          <ProtectionPlansPenProducts
            dealer={dealer}
            actions={actions}
            fetching={fetching}
          />
        );
      case protectionPlanSteps.BUNDLES:
        return <ProtectionPlansPenBundles dealer={dealer} actions={actions} />;
      default:
        return (
          <ProtectionPlansPenProducts
            dealer={dealer}
            actions={actions}
            fetching={fetching}
          />
        );
    }
  };

  const getNextStepParam = (param) => {
    const index = steps.findIndex((step) => step.param === param);
    if (index + 1 < steps.length) {
      return steps[index + 1].param;
    }
    if (index + 1 === steps.length) {
      return steps[0].param;
    }
    return steps[steps.length - 1].param;
  };

  const onPenSave = () => {
    const dealerUpdatePayload = {
      id: dealer.id,
      penConfig: {},
    };

    if (pen.penConfig) {
      dealerUpdatePayload.penConfig.enableInUI = clone(
        pen.penConfig.enableInUI,
      );
      dealerUpdatePayload.penConfig.multiBundlesInDeal = clone(
        pen.penConfig.multiBundlesInDeal,
      );
      dealerUpdatePayload.penConfig.hideProductPrices = clone(
        pen.penConfig.hideProductPrices,
      );
      dealerUpdatePayload.penConfig.showTotalCost = clone(
        pen.penConfig.showTotalCost,
      );
      dealerUpdatePayload.penConfig.showDailyPrice = clone(
        pen.penConfig.showDailyPrice,
      );
      dealerUpdatePayload.penConfig.useSelectedOfferTermsAndMiles = clone(
        pen.penConfig.useSelectedOfferTermsAndMiles,
      );
    }

    const pps = get(pen, 'penConfig.protectionPlanSource');
    if (pps) {
      dealerUpdatePayload.protectionPlanSource = pps;
    }

    const nextStepParam = getNextStepParam(page);

    actions.updateDealerRequest({
      dealer: dealerUpdatePayload,
      isDiffObject: true,
      route: `/${dealer.id}/protection-plans/${nextStepParam}`,
    });
  };

  const onStepClick = (param) => {
    history.push(`/${dealer.id}/protection-plans/${param}`);
  };

  return (
    <div>
      {page === protectionPlanSteps.REGISTRATION && renderPenPage(page)}
      {page !== protectionPlanSteps.REGISTRATION && (
        <div>
          <StepList steps={steps} step={page} onStepClick={onStepClick} />
          {renderPenPage(page)}
          <div className="button-container">
            <button
              className="btn btn-primary"
              onClick={() => {
                props.history.push(`/dealer/${dealer.id}`);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                onPenSave();
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

ProtectionPlansPen.propTypes = {
  dealer: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
  page: PropTypes.string,
  pen: PropTypes.object,
  fetching: PropTypes.bool,
};

const mapStateToProps = ({ pen }) => ({
  pen,
});

export default connect(mapStateToProps)(ProtectionPlansPen);
